/* fs-gift-addresses.js (Oct 27 2026, Deputy build, STAGED + DORMANT)
   The gift-addresses form. Shopify's contact form emails the store with every named field.
   - Recipient 1 is required. Recipients 2..N become required only once any field in that recipient is filled in.
   - On submit it writes a plain-text summary of everything into the message box, so the email reads cleanly.
   - Disables the button after one tap so a double tap cannot send two emails. */
(function () {
  var form = document.getElementById('fsh-gift-form');
  if (!form) return;
  var groups = Array.prototype.slice.call(form.querySelectorAll('[data-recipient]'));
  var REQ = ['name', 'street', 'city', 'province', 'postal', 'gifts'];

  function fieldsOf(g) { return Array.prototype.slice.call(g.querySelectorAll('input, select, textarea')); }
  function anyFilled(g) { return fieldsOf(g).some(function (f) { return (f.value || '').trim() !== ''; }); }
  function sync() {
    groups.forEach(function (g, i) {
      var need = (i === 0) || anyFilled(g);
      fieldsOf(g).forEach(function (f) {
        if (REQ.indexOf(f.getAttribute('data-req-key')) > -1) {
          if (need) f.setAttribute('required', 'required'); else f.removeAttribute('required');
        }
      });
    });
  }
  form.addEventListener('input', sync);
  form.addEventListener('change', sync);
  sync();

  // FIX ROUND 1 (B4): Gift 1 is open; the others open one at a time from "Add another address". A gift she already filled in (back button) stays open.
  var adders = Array.prototype.slice.call(form.querySelectorAll('[data-add-next]'));
  function reveal(k) {
    if (!groups[k]) return;
    groups[k].hidden = false;
    if (adders[k - 1]) adders[k - 1].hidden = true;
    if (adders[k]) adders[k].hidden = false;
  }
  groups.forEach(function (g, i) { if (i > 0 && anyFilled(g)) reveal(i); });
  adders.forEach(function (btn, k) {
    btn.addEventListener('click', function () {
      reveal(k + 1);
      var first = groups[k + 1] && groups[k + 1].querySelector('input, select, textarea');
      if (first) first.focus();
    });
  });

  form.addEventListener('submit', function () {
    var v = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? (el.value || '').trim() : ''; };
    var lines = ['GIFT ADDRESSES', 'Order number: ' + v('contact[Order number]'), 'From: ' + v('contact[name]') + ' <' + v('contact[email]') + '>', ''];
    groups.forEach(function (g, i) {
      if (!anyFilled(g)) return;
      var gv = function (k) { var el = g.querySelector('[data-req-key="' + k + '"]'); return el ? (el.value || '').trim() : ''; };
      lines.push('Recipient ' + (i + 1) + ': ' + gv('name'));
      lines.push('  ' + gv('street') + ', ' + gv('city') + ', ' + gv('province') + ' ' + gv('postal').toUpperCase());
      lines.push('  Gifts: ' + gv('gifts'));
      if (gv('note')) lines.push('  Gift note: ' + gv('note'));
      lines.push('');
    });
    var body = form.querySelector('[name="contact[body]"]');
    if (body) body.value = lines.join('\n');
    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      var label = btn.getAttribute('data-label') || btn.textContent;
      btn.setAttribute('data-label', label);
      btn.disabled = true; btn.textContent = 'Sending…';
      // Shopify's own spam check (hCaptcha) can pause the first submit. If the page is still here after 8 seconds, let her tap again.
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 8000);
    }
  });
})();
